<template>
    <div>
        <!-- Modal Evoluções -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Evoluções</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="form-row mb-3">
                            <div class="col col-12">
                                <az-periodo
                                    :sync="true" 
                                    @sync="load()"
                                    v-model="filtro" />
                            </div>

                            <div class="col col-12 col-md-4" v-if="false">
                                <az-input
                                    icon="fa-solid fa-magnifying-glass"
                                    placeholder="Pesquisar..."
                                    v-model="filtro.search" />
                            </div>
                        </div>

                        <az-empty-state 
                            v-if="!lista_registros_calc_data || !lista || !lista.registros || !lista.registros.length" 
                            message="Nenhuma evolução encontrada para o período selecionado." />

                        <template v-else-if="lista_registros_calc_data">
                        
                            <template v-for="(registros, data, idx) in lista_registros_calc_data">

                                <div class="card mb-1" v-if="!data_filtro || data_filtro === data" :key="idx">
                                    <div class="card-header d-flex justify-content-between">
                                        <a href="#" @click.prevent="$set(lista_registros_datas, data, !lista_registros_datas[data])" class="card-link">
                                            {{ $util.getFormatDate(data) }} | {{ $util.getFormatDate(data, 'dddd') }} | {{ getHumanDuration(data) }}
                                        </a>
                                        <div>
                                            <span class="badge badge-secondary">{{ registros.length }}</span>
                                        </div>
                                    </div>
                                    <div class="card-body" v-if="lista_registros_datas && lista_registros_datas[data]">

                                        <div v-for="(registro, iregx) in registros" :key="iregx">

                                            <div v-if="registro.id_atendimento_registro && registro.st_conteudo && registro.st_conteudo.length">
                                                <az-sub-title :title="titulo_registro(registro, true)" :showhide="registro.id_atendimento_registro" :model="registro">
                                                    <!-- 
                                                    <az-audit-log-button model="atendimentoRegistro" :id="registro.id_atendimento_registro" sizing="sm" />
                                                    <button type="button" class="btn btn-outline-secondary btn-sm ml-1" @click="imprimir_registro(registro)">
                                                        <i class="fa fa-print" aria-hidden="true"></i>
                                                    </button>    
                                                    <span v-if="registro.doc_certificados && registro.doc_certificados.length > 1">
                                                        <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="ver_docs(registro)">
                                                            <i class="fas fa-file-contract"></i>
                                                        </button>
                                                    </span>
                                                    <span v-else-if="registro.doc_certificado && registro.doc_certificado_link">
                                                        <a :href="registro.doc_certificado_link" class="btn btn-outline-primary btn-sm ml-1" target="_blank">
                                                            <i class="fas fa-file-contract"></i>
                                                        </a>
                                                    </span>
                                                    <span v-else-if="registro.doc_certificado">
                                                        <button type="button" class="btn btn-outline-primary btn-sm ml-1" disabled>
                                                            <i class="fas fa-file-contract ml-1"></i>
                                                        </button>
                                                    </span>
                                                    -->

                                                    <span v-if="registro.doc_certificado && registro.doc_certificado_link">
                                                        <a :href="registro.doc_certificado_link" class="btn btn-outline-primary btn-sm ml-1" target="_blank">
                                                            <i class="fas fa-file-contract"></i>
                                                        </a>
                                                    </span>

                                                    <button class="btn btn-outline-primary btn-sm ml-1" type="button" @click="toggle_expandir_registros ()" title="Expandir/Recolher detalhes dos atendimentos." v-if="registros.length > 1">
                                                        <i class="fas fa-compress-arrows-alt"></i>
                                                    </button>
                                                </az-sub-title>

                                                <template v-if="registro && !registro.hide">
                                                    <campos-formulario 
                                                        :validate="validate"
                                                        v-model="registro.st_conteudo" 
                                                        :raiz="true" 
                                                        mode="view"
                                                        :compact="registro.modelo ? registro.modelo.fl_compact: false"
                                                        :modelo="registro.modelo" />
                                                </template>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </template>

                        </template>
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import _ from 'lodash'; 
import $ from 'jquery';
import * as moment from "moment";
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import CamposFormulario from '../consultorio/CamposFormulario.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return {
            lista: null, 
            lista_registros_datas: [], 
            lista_registros_calc_data: null, 
            data_filtro: null, 
            id_internacao: null,
            dt_inicio: null,
            dt_fim: null,
            filtro: {
                periodo: "", 
                inicio: null,
                fim: null, 
                search: "", 
            },
            validate: false, 
        };
    },

    components: { 
        AzPeriodo, 
        CamposFormulario,
        AzSubTitle,
        AzEmptyState,
        AzInput,
    },
  
    computed: { 
        modal_name: function() {
            return 'evol_modal_' + this.chave;
        }
    },

    methods: { 
        toggle_expandir_registros () { 
            let tem_hide = this.lista.registros.find(registro => registro.fl_ativo && registro.id_atendimento_registro && registro.hide);

            this.lista.registros.forEach(registro => { 
                if ( registro.id_atendimento_registro ) { 
                    registro.hide = tem_hide ? false : true;
                }
            });
        },

        getHumanDuration(date) {
            if (date.substr(0, 10) == this.$util.hoje()) return "hoje";
            else
                {
                moment.relativeTimeRounding(Math.floor);
                return moment
                    .duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje()))
                    .humanize(true);
                } 
        },

        fechar_modal() {
            $('#' + this.modal_name).modal('hide');
        },

        titulo_registro(registro, show_modelo = false, block_proc = false) { 
            return ( ( !block_proc && registro.procedimento ) ? registro.procedimento.search + ': ' : '' ) 
                + ( show_modelo ? ( registro.modelo.st_modelo_prontuario + ' - ' ) : '' )
                + _.get(registro, 'usuario.pessoa.st_nome') + ', ' 
                + ( !registro.created_at 
                    ? 'Novo' 
                    : ( this.$util.getFormatDate(registro.created_at) + ' ' + registro.created_at.substr(11,5) ) )
        },

        init () { 
            this.lista_registros_datas = []; 

            this.lista_registros_calc_data = _.groupBy(
                _.orderBy(
                    this.lista.registros.filter(registro => registro.fl_ativo && registro.id_atendimento_registro),
                    'created_at',
                    'desc'
                ), 
                item => { 
                    console.log('item', item);
                    return item ? item.created_at.slice(0,10) : '-';
                }
            );

            _.each(this.lista_registros_calc_data, (item, data) => { 
                this.$set(this.lista_registros_datas, data, false);
            });
        },

        abrir(id_internacao, dt_inicio, dt_fim) { 

            this.lista_registros_calc_data = null; 
            this.id_internacao = id_internacao;
            this.dt_inicio = dt_inicio;
            this.dt_fim = dt_fim;

            this.filtro.inicio = this.dt_inicio;
            this.filtro.fim = this.dt_fim;

            $('#' + this.modal_name).modal('show');

            this.load(); 

        },

        load() { 
            
            this.$util.load(this, { 
                service: 'enfermagem',
                func: 'evolucoes',
                parms: { 
                    id_internacao: this.id_internacao,
                    ...this.filtro, 
                },
                loadTo: res => { 
                    this.lista = res;
                    this.init();
                }
            });

        }
    },

    mounted() { 
        this.chave = this.$util.uuidv4(); 
    }

}
</script>
